import React from 'react';
import { TableLoadingIcon } from '../Styled/Icons';

export default (loading) => ({
  spinning: loading,
  indicator: <TableLoadingIcon />,
});
